import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["name"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { default as CardholderNameValidator } from './fieldValidators/CardholderNameValidator';
import ValidationHelper, { VALIDATION_TYPES, CCFIELDS } from './ValidationHelper';
import ValidationMessages from './ValidationMessages';
import { validateField, getMessage } from './ValidationField';
var FIELD_VALIDATION_MAP = ValidationHelper.FIELD_VALIDATION_MAP;
export var FORM_TYPES = {
  PAYMENT_FORM: 'PaymentForm'
};
export var VALIDATORS = _defineProperty({}, FORM_TYPES.PAYMENT_FORM, [CardholderNameValidator]);

/**
 * validates all the fields in a form that require validation
 * @param formType
 * @param form
 * @returns {StringMap<FormFieldData>} - a map of fields that failed validation
 */
var validateForm = function validateForm(formType, form) {
  var validators = VALIDATORS[formType];
  var fields = {};
  validators.forEach(function (validator) {
    var validated = validator.validate(form);
    if (validated.error !== '') {
      var name = validated.name,
        rest = _objectWithoutProperties(validated, _excluded);
      fields[name] = _objectSpread({}, rest);
    }
  });
  return fields;
};
var Types = {
  VALIDATION_TYPES: VALIDATION_TYPES,
  FORM_TYPES: FORM_TYPES,
  CCFIELDS: CCFIELDS
};
export var ValidationManager = {
  validateForm: validateForm,
  validateField: validateField,
  getMessage: getMessage,
  fieldValidationMap: FIELD_VALIDATION_MAP,
  ValidationMessages: ValidationMessages,
  types: Types
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/business/validators/ValidationManager.js
// module id = 3500
// module chunks = 11